import { Controller } from "@hotwired/stimulus"

const COOKIE = "sidebar_subpages_open"

// The accordion under a sidebar entry with sub-pages (Sidebar::ItemComponent). The server opens
// the one the current page belongs to, and any other the user opened: those are remembered per
// browser in a cookie (Sidebar::ItemComponent::SUBPAGES_COOKIE) the server reads, so a
// remembered accordion renders open instead of jumping open after every visit. A convenience of
// this screen, not a setting worth an account write on every click.
export default class extends Controller {
  static targets = ["toggle", "chevron", "list"]
  static values = { key: String }

  toggle() {
    const open = this.listTarget.classList.contains("hidden")
    this.apply(open)
    this.writeStored(open)
  }

  apply(open) {
    this.listTarget.classList.toggle("hidden", !open)
    this.chevronTarget.classList.toggle("-rotate-90", !open)
    this.toggleTarget.setAttribute("aria-expanded", String(open))
  }

  readStored() {
    const entry = document.cookie.split("; ").find((pair) => pair.startsWith(`${COOKIE}=`))
    if (!entry) return []
    return decodeURIComponent(entry.slice(COOKIE.length + 1))
      .split(",")
      .filter(Boolean)
  }

  writeStored(open) {
    const keys = this.readStored().filter((key) => key !== this.keyValue)
    if (open) keys.push(this.keyValue)
    document.cookie = keys.length
      ? `${COOKIE}=${encodeURIComponent(keys.join(","))}; path=/; max-age=31536000; SameSite=Lax`
      : `${COOKIE}=; path=/; max-age=0; SameSite=Lax`
  }
}
